import React from "react";
import {
  Button,
  Circle,
  HStack,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Spacer,
  Text
} from "@chakra-ui/react";
import { ColumnInstance, Filters } from "react-table";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";

interface Props {
  columns: ColumnInstance[];
  filters: Filters<any>;
}

const FilterDropdown: React.FC<Props> = ({ columns, filters }: Props) => {
  const filterable = columns.filter(col => col.Filter && !col.disableFilters);
  if (filterable.length <= 0) return null;
  return (
    <Popover placement="bottom-end">
      {({ isOpen }) => (
        <>
          <PopoverTrigger>
            <Button
              size="sm"
              variant="dark"
              rounded="lg"
              leftIcon={
                <Icon
                  as={isOpen ? AiFillCaretUp : AiFillCaretDown}
                  color="blue.500"
                  w={6}
                  h={6}
                />
              }
              rightIcon={
                filters.length > 0 ? (
                  <Circle centerContent size="25px" bgColor="blue.500">
                    <Text fontWeight="medium" color="gray.900">
                      {filters.length}
                    </Text>
                  </Circle>
                ) : undefined
              }
            >
              Filters
              <Spacer />
            </Button>
          </PopoverTrigger>
          <PopoverContent background="gray.800">
            <PopoverBody>
              <HStack spacing={3}>
                {filterable.map(column => (
                  <div key={column.id}>{column.render("Filter")}</div>
                ))}
              </HStack>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default FilterDropdown;
